import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import './autocomplete.scss'
import { InputAdornment } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
interface iProps {options:{label:string,id:number}[],value:any
  ,onChange:(e:React.ChangeEvent<HTMLInputElement>)=>void
  ,label:string,isLoading:boolean,fetchData:Function,isLoaded:boolean}
export default function AutoComplete({
  label,onChange,options,value,isLoading,fetchData,isLoaded
}:iProps) {
  
  React.useEffect(()=>{
    if (!isLoading && !isLoaded)
    fetchData()
  },[])
  return (
    <div className='autoComplete input-box'>
    <input 
    className='autocomplete-input'
    value={value}
    onChange={onChange}
    autoComplete='on'
    list="myList"
    />
      <datalist id="myList">
        {
          options.map((ele,index)=><option key={index} value={ele.label}/>)
        }
      </datalist>
      </div>

   
  );
}

